import Avatar from './index.vue'

Avatar.install = Vue => {
  Vue.component(Avatar.name, Avatar)
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/avatar/index.js